import { render, staticRenderFns } from "./MilkExtractionReport.vue?vue&type=template&id=433fb726&scoped=true&"
import script from "./MilkExtractionReport.vue?vue&type=script&lang=js&"
export * from "./MilkExtractionReport.vue?vue&type=script&lang=js&"
import style0 from "./MilkExtractionReport.vue?vue&type=style&index=0&id=433fb726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433fb726",
  null
  
)

export default component.exports